import { APPLICANT_STATUS } from '@/data/default'

const campaignListBusiness = [
  {
    id: 'GoldVermeilRings',
    companyName: 'Rings Company',
    productName: 'Gold Vermeil Rings',
    productValue: 350,
    productCategory: 'accessories',
    productTag: ['ring', 'gift', 'gold'],
    productDescription: "Gold vermeil rings are an affordable and luxurious option for jewelry lovers. With a thick layer of 18k gold over sterling silver, these rings have the durability and beauty of gold without the high price tag. The warm tones of the gold complement any outfit and can be worn for any occasion, from casual to formal. The timeless design of these rings ensures they will remain a cherished addition to your jewelry collection for years to come.",
    maxTotalSales: 5000,
    influencerMaxSales: 1000,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: true,
    imageName: 'rings',
    totalRevenue: 77000,
    totalSales: 220,
    totalCommission: 6846,
    influencerNum: 4,
    activeDate: '7/11/2023 - 9/22/2023',
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'Sarah Johnson',
        level: 21,
        avatarImage: 'influencer-0',
        currentTier: 3,
        soldNum: 120,
        revenue: 42000,
        commission: 3969,
      },
      {
        rank: 2,
        name: 'Jessica Ramirez',
        level: 13,
        avatarImage: 'influencer-1',
        currentTier: 2,
        soldNum: 60,
        revenue: 21000,
        commission: 1757,
      },
      {
        rank: 3,
        name: 'Anthony lee',
        level: 7,
        avatarImage: 'influencer-2',
        currentTier: 1,
        soldNum: 30,
        revenue: 10500,
        commission: 840,
      },
      {
        rank: 4,
        name: 'Michael Davis',
        level: 2,
        avatarImage: 'influencer-5',
        currentTier: 1,
        soldNum: 10,
        revenue: 3500,
        commission: 280,
      },
    ],
  },
  {
    id: 'MinimalisticWatch',
    companyName: 'Watch Company',
    productName: 'Minimalistic Watch',
    productValue: 450,
    productCategory: 'accessories',
    productTag: ['watch', 'gift', 'time'],
    productDescription: "The Minimalistic Watch is a stylish timepiece that embodies simplicity and elegance. Its sleek and understated design features a clean, uncluttered face with slim hour markers and slim hands, housed in a slim and lightweight case. With its versatile style, it's the perfect accessory for any occasion.",
    maxTotalSales: 2000,
    influencerMaxSales: 500,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: false,
    imageName: 'watch',
    totalRevenue: 20250,
    totalSales: 45,
    totalCommission: 1620,
    influencerNum: 1,
    activeDate: '7/11/2023 - 9/22/2023',
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'Samantha Taylor',
        level: 21,
        avatarImage: 'influencer-3',
        currentTier: 1,
        soldNum: 45,
        revenue: 20250,
        commission: 1620,
      },
    ],
  },
  {
    id: 'BabyBlueShoulderBag',
    companyName: 'Bag Company',
    productName: 'Baby Blue Shoulder Bag',
    productValue: 500,
    productCategory: 'accessories',
    productTag: ['bag', 'gift', 'blue'],
    productDescription: "The Baby Blue Shoulder Bag is a stylish and practical accessory for any outfit. With a soft blue exterior and a durable shoulder strap, this bag features multiple pockets for easy organization and storage. Perfect for carrying essentials like keys, phone, wallet, and more.",
    maxTotalSales: 5000,
    influencerMaxSales: 1000,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: false,
    imageName: 'bag',
    totalRevenue: 0,
    totalSales: 0,
    totalCommission: 0,
    influencerNum: 0,
    activeDate: '7/11/2023 - 9/22/2023',
  },
  {
    id: 'sunglasses',
    companyName: 'Sun Glasses Company',
    productName: 'Sun Glasses',
    productValue: 250,
    productCategory: 'accessories',
    productTag: ['glass', 'gift', 'sun'],
    productDescription: 'These stylish sunglasses offer both fashion and function. With their sleek design and UV-protective lenses, they are perfect for any outdoor activity. The lightweight frame and comfortable fit make them easy to wear all day. Whether you are at the beach or just running errands, these sunglasses are a must-have accessory.',
    maxTotalSales: 3000,
    influencerMaxSales: 600,
    missionGuideline: 'For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!',
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: false,
    imageName: 'sunglasses',
    totalRevenue: 30000,
    totalSales: 120,
    totalCommission: 2555,
    influencerNum: 2,
    activeDate: '7/11/2023 - 9/22/2023',
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'David Kim',
        level: 20,
        avatarImage: 'influencer-6',
        currentTier: 2,
        soldNum: 80,
        revenue: 20000,
        commission: 1755,
      },
      {
        rank: 2,
        name: 'Rachel Chen',
        level: 6,
        avatarImage: 'influencer-4',
        currentTier: 1,
        soldNum: 40,
        revenue: 10000,
        commission: 800,
      },
    ],
  },
]

/** LevelRange
    A: 0-5,
    B: 6-9,
    C: 10-19,
    D: 20-29,
    E: 30~
*/

const campaignProductCategoryInfo = [
  { id: 'clothing', name: 'Clothing' },
  { id: 'shoes', name: 'Shoes' },
  { id: 'accessories', name: 'Accessories'},
  { id: 'game', name: 'Game' },
  { id: 'furniture', name: 'Furniture' },
  { id: 'health', name: 'Health' },
  { id: 'baby', name: 'Baby' },
  { id: 'food', name: 'Food' },
  { id: 'beautypersonal', name: 'Beauty & Personal Care' },
  { id: 'consumer', name: 'Consumer Electronics' },
  { id: 'sports', name: 'Sports' },
]

const influencerAge = [
  { id: 'all', name: 'All age', value: 'all' },
  { id: 'teenager', name: '11 - 17', value: '0' },
  { id: 'middle', name: '18 - 29', value: '1' },
  { id: 'adult', name: '30 - 40', value: '2' },
  { id: 'old', name: '40+', value: '3' },
]

const influencerLevel = [
  { id: 'all', name: 'All level', value: 'all' },
  { id: 'teenager', name: '0 - 9', value: '0' },
  { id: 'middle', name: '10 - 19', value: '1' },
  { id: 'adult', name: '20 - 29', value: '2' },
  { id: 'old', name: '30 - 39', value: '3' },
]

const influencerGender = [
  { id: 'all', name: 'All gender'},
  { id: 'male', name: 'Male' },
  { id: 'female', name: 'Female' },
  { id: 'transgender', name: 'Transgender' },
  { id: 'genderNeutral', name: 'Gender neutral' },
  { id: 'nonBinary', name: 'Non-binary' },
]

const influencerCategoryInfo = [
  { id: 'all', name: 'All category' },
  { id: 'beauty', name: 'Beauty and skincare' },
  { id: 'health', name: 'Health and wellness' },
  { id: 'fashion', name: 'Fashion and apparel' },
  { id: 'food', name: 'Food and beverages' },
  { id: 'fitness', name: 'Fitness' },
  { id: 'travel', name: 'Travel and tourism' },
  { id: 'technology', name: 'Technology and gadgets' },
  { id: 'home', name: 'Home and lifestyle' },
  { id: 'entertainment',  name: 'Entertainment and media'},
  { id: 'gaming', name: 'Gaming' },
]

const influencerPlatform = [
  { id: 'all', name: 'All platform'},
  { id: 'instagram', name: 'Instagram' },
  { id: 'tiktok', name: 'Tiktok' },
  { id: 'facebook', name: 'Facebook' },
  { id: 'youtube', name: 'Youtube' },
]

const influencerList = [
  {
    id: 'sarahjohnson',
    name: 'Sarah Johnson',
    avatarImage: 'influencer-0',
    level: 21,
    levelRange: 'D',
    exp: 23,
    isLiked: true,
    campaignName: 'Gold Vermeil Rings',
    campaignImage: 'rings',
    status: APPLICANT_STATUS.Pending,
    pendingDate: '5/2/2023',
    description: "Hey there! My name is Sarah, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Beauty and skincare',
        image: 'Beauty',
        exp: 40,
      },
      {
        name: 'Health and wellness',
        image: 'Health',
        exp: 46,
      },
      {
        name: 'Fashion and apparel',
        image: 'Fashion',
        exp: 90,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
  {
    id: 'jessicaramirez',
    name: 'Jessica Ramirez',
    avatarImage: 'influencer-1',
    level: 13,
    levelRange: 'C',
    exp: 50,
    isLiked: true,
    campaignName: 'Minimalistic Watch',
    campaignImage: 'watch',
    pendingDate: '4/15/2023',
    status: APPLICANT_STATUS.Pending,
    description: "Hey there! My name is Jessica, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Travel and tourism',
        image: 'Travel',
        exp: 66,
      },
      {
        name: 'Health and wellness',
        image: 'Health',
        exp: 77,
      },
      {
        name: 'Home and lifestyle',
        image: 'Home',
        exp: 88,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
  {
    id: 'anthonylee',
    name: 'Anthony lee',
    avatarImage: 'influencer-2',
    level: 7,
    levelRange: 'B',
    exp: 80,
    isLiked: false,
    campaignName: 'Baby Blue Shoulder Bag',
    campaignImage: 'bag',
    pendingDate: '4/22/2023',
    status: APPLICANT_STATUS.Pending,
    step: null,
    description: "Hey there! My name is Anthony, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Technology and gadgets',
        image: 'Technology',
        exp: 33,
      },
      {
        name: 'Entertainment and media',
        image: 'Entertainment',
        exp: 22,
      },
      {
        name: 'Gaming',
        image: 'Gaming',
        exp: 88,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
  {
    id: 'michaeldavis',
    name: 'Michael Davis',
    avatarImage: 'influencer-5',
    level: 2,
    levelRange: 'A',
    exp: 66,
    isLiked: false,
    campaignName: 'Minimalistic Watch',
    campaignImage: 'watch',
    invitedDate: '5/13/2023',
    status: APPLICANT_STATUS.Invited,
    description: "Hey there! My name is Michael, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Gaming',
        image: 'Gaming',
        exp: 66,
      },
      {
        name: 'Entertainment and media',
        image: 'Entertainment',
        exp: 77,
      },
      {
        name: 'Home and lifestyle',
        image: 'Home',
        exp: 88,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
  {
    id: 'rachelchen',
    name: 'Rachel Chen',
    avatarImage: 'influencer-4',
    level: 6,
    levelRange: 'B',
    exp: 40,
    isLiked: false,
    campaignName: 'Sun Glasses',
    campaignImage: 'sunglasses',
    matchedDate: '4/22/2023',
    status: APPLICANT_STATUS.Matched,
    currentStep: 4,
    description: "Hey there! My name is Rachel, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Travel and tourism',
        image: 'Travel',
        exp: 66,
      },
      {
        name: 'Health and wellness',
        image: 'Health',
        exp: 77,
      },
      {
        name: 'Home and lifestyle',
        image: 'Home',
        exp: 88,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
  {
    id: 'davidkim',
    name: 'David Kim',
    avatarImage: 'influencer-6',
    level: 20,
    levelRange: 'D',
    exp: 66,
    isLiked: false,
    campaignName: 'Sun Glasses',
    campaignImage: 'sunglasses',
    matchedDate: '4/22/2023',
    status: APPLICANT_STATUS.Default,
    currentStep: 4,
    description: "Hey there! My name is David, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Fashion and apparel',
        image: 'Fashion',
        exp: 33,
      },
      {
        name: 'Health and wellness',
        image: 'Health',
        exp: 77,
      },
      {
        name: 'Home and lifestyle',
        image: 'Home',
        exp: 88,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
  {
    id: 'juanmartinez',
    name: 'Juan Martinez',
    avatarImage: 'influencer-7',
    level: 10,
    levelRange: 'B',
    exp: 54,
    isLiked: false,
    campaignName: 'Sun Glasses',
    campaignImage: 'sunglasses',
    matchedDate: '4/22/2023',
    status: APPLICANT_STATUS.Default,
    currentStep: 4,
    description: "Hey there! My name is Juan, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Technology and gadgets',
        image: 'Technology',
        exp: 33,
      },
      {
        name: 'Entertainment and media',
        image: 'Entertainment',
        exp: 77,
      },
      {
        name: 'Home and lifestyle',
        image: 'Home',
        exp: 88,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
  {
    id: 'samanthataylor',
    name: 'Samantha Taylor',
    avatarImage: 'influencer-3',
    level: 21,
    levelRange: 'D',
    exp: 87,
    isLiked: false,
    campaignName: 'Sun Glasses',
    campaignImage: 'sunglasses',
    matchedDate: '4/22/2023',
    status: APPLICANT_STATUS.Default,
    currentStep: 4,
    description: "Hey there! My name is Samantha, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
    categoryList: [
      {
        name: 'Technology and gadgets',
        image: 'Technology',
        exp: 33,
      },
      {
        name: 'Entertainment and media',
        image: 'Entertainment',
        exp: 77,
      },
      {
        name: 'Home and lifestyle',
        image: 'Home',
        exp: 88,
      }
    ],
    socialMedia: [
      {
        name: 'Tiktok',
        fansNum: 533,
        image: 'tiktok',
        icon: ['fab', 'tiktok']
      },
      {
        name: 'Youtube',
        fansNum: 85,
        image: 'youtube',
        icon: ['fab', 'youtube']
      },
      {
        name: 'Instagram',
        fansNum: 300,
        image: 'instagram',
        icon: ['fab', 'instagram']
      },
      {
        name: 'Facebook',
        fansNum: 106,
        image: 'facebook',
        icon: ['fab', 'square-facebook']
      },
    ],
  },
]

export {
  campaignListBusiness,
  campaignProductCategoryInfo,
  influencerAge,
  influencerLevel,
  influencerGender,
  influencerCategoryInfo,
  influencerPlatform,
  influencerList,
}